import {isFeatureEnabled} from '@github-ui/feature-flags'
import {registerDataRouterApp} from '@github-ui/react-core/register-app'

import {reposListAppBuilder} from './config/app-builder'
import {orgReposPageRoute} from './routes/org-repos-page-route'
import {OrgReposPageForDataRouter} from './routes/OrgReposPage'
import {repositoriesPageRoute} from './routes/repositories-page-route'

export const reposListApp = reposListAppBuilder.createDataRouterAppFromRoutes(() =>
  isFeatureEnabled('org_repos_page_route')
    ? [orgReposPageRoute.toRoute({Component: OrgReposPageForDataRouter})]
    : [repositoriesPageRoute.toRoute({Component: OrgReposPageForDataRouter})],
)
registerDataRouterApp(reposListApp)
